export default __webpack_public_path__ + "static/media/sre-automation-book.8605949a.png";